var React = require('react');

function Globe (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_862","data-name":"Rectangle 862","width":"16","height":"16","fill":"none","key":0}),React.createElement("g",{"id":"icons8-globe","transform":"translate(-1.6 -1.6)","key":1},[React.createElement("path",{"id":"Path_16364","data-name":"Path 16364","d":"M9.6,2.4a7.2,7.2,0,1,0,7.2,7.2A7.2,7.2,0,0,0,9.6,2.4Z","fill":"rgba(0,0,0,0)","stroke":"#66a9f4","strokeMiterlimit":"10","strokeWidth":"1.2","key":0}),React.createElement("path",{"id":"Path_16365","data-name":"Path 16365","d":"M9.6,2.4c-1.767,0-3.2,3.224-3.2,7.2s1.433,7.2,3.2,7.2,3.2-3.224,3.2-7.2S11.367,2.4,9.6,2.4ZM2.4,7.2H16.8M2.4,12H16.8","fill":"rgba(0,0,0,0)","stroke":"#66a9f4","strokeMiterlimit":"10","strokeWidth":"1.2","key":1})])]);
}

Globe.defaultProps = {"id":"icon-online-app","width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Globe;

Globe.default = Globe;
